import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";

type Props = {
  label: string;
  value: React.ReactNode;
};

export function PlanInfoField({ label, value }: Props) {
  return (
    <MDBox mb={1}>
      <MDTypography variant="body2" color="text" lineHeight={1.5}>
        <MDTypography component="span" variant="body2" fontWeight="bold" color="dark">
          {label}:
        </MDTypography>{" "}
        {value}
      </MDTypography>
    </MDBox>
  );
}

export default PlanInfoField;
